import React from "react";
import { parseAnimTokens } from "@/utils/text";
import { AnimWord } from "./styles";

export type AnimatedSentenceProps = {
  sentence: string;
  revealed: boolean;
  animate: boolean;
  baseDelay?: number;
  stepMs?: number;
  components?: Record<string, React.ReactElement>;
};

export const AnimatedSentence: React.FC<AnimatedSentenceProps> = ({
  sentence,
  revealed,
  animate,
  baseDelay = 0,
  stepMs = 120,
  components,
}) => {
  const tokens = parseAnimTokens(sentence);

  return (
    <>
      {tokens.map((token, i) => (
        <React.Fragment key={i}>
          <AnimWord $on={revealed} $anim={animate} $d={baseDelay + i * stepMs}>
            {token.type === "tagged" && components?.[token.tag]
              ? React.cloneElement(components[token.tag]!, {}, token.text)
              : token.text}
          </AnimWord>
          {i < tokens.length - 1 ? " " : null}
        </React.Fragment>
      ))}
    </>
  );
};
